module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll"
  }, [(!_vm.hasError) ? _vm._t("default") : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticClass: "net-warning-pic",
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_c('p', {
    staticClass: "net-warning-text"
  }, [_vm._v("网络连接失败")]), _vm._v(" "), _c('p', {
    staticClass: "net-warning-tips"
  }, [_vm._v("请检查网络连接是否正常")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a12b68","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroll.vue
// module id = 858
// module chunks = 0